import styled from 'styled-components'
import query from 'mediaQueries'
import AlertBanner from 'ui/atoms/AlertBanner'
import { Body as CLBody } from 'syf-component-library/ui/typography'

export const AuthCodeNotAvailableBanner = styled(AlertBanner)`
  width: 100%;
`

export const Body = styled(CLBody)<{ isSmall?: boolean }>`
  font-size: ${({ isSmall }) => (isSmall ? '12px' : '14px')};
`

export const AuthenticationText = styled(Body)`
  @media ${query.greaterThanSmall} {
    width: 400px;
  }
`
